import { render, staticRenderFns } from "./NewEntityBtn.vue?vue&type=template&id=b304f438&scoped=true&"
import script from "./NewEntityBtn.vue?vue&type=script&lang=js&"
export * from "./NewEntityBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b304f438",
  null
  
)

export default component.exports